import type { QuickBooksRefreshReceipt } from '../../../data/ServerApiClient'

export const CFO_REFRESH_REQUESTED_EVENT = 'fg:cfo-refresh-requested'

/** Wake the existing observer. The browser never owns report continuation. */
export function announceCfoRefresh(workbookId: string, refresh?: QuickBooksRefreshReceipt | null) {
  window.dispatchEvent(new CustomEvent(CFO_REFRESH_REQUESTED_EVENT, { detail: { workbookId, refresh } }))
}
